import $$ from 'cmn-utils'

const baseUrl = "/api/safety/danger/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    submit: (params) => {
        return $$.post(baseUrl + 'submit', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    updateProcessing: (params) => {
        return $$.post(baseUrl + 'update-processing', params)
    },
    reportExportExcel: (params) => {
        return $$.get(baseUrl + 'report/export-excel', params)
    },
}